import { Box } from '@mui/material';

interface StatusDotProps {
  /** Theme palette path (e.g. 'success.main') or any CSS colour. */
  color: string;
}

/** 8px status dot. Decorative — a status word must reach the user elsewhere. */
export const StatusDot = ({ color }: StatusDotProps) => (
  <Box
    component="span"
    aria-hidden
    sx={{
      display: 'inline-block',
      width: 8,
      height: 8,
      borderRadius: '50%',
      bgcolor: color,
      flexShrink: 0,
    }}
  />
);
